import css from './Schedule.module.css';

function ZoomControls({ zoom, setZoom, ZOOM_LEVELS }) {
  return (
    <div className={css.zoomControls}>
      {Object.keys(ZOOM_LEVELS).map((level) => (
        <button
          key={level}
          className={zoom === level ? css.activeZoom : css.zoomButton}
          onClick={() => setZoom(level)}
        >
          {level}
        </button>
      ))}
    </div>
  );
}

export default ZoomControls;
